function rem(size, base = 18) {
  return `${size / base}rem`
}

export default rem
